import { ProtectionExtraIds } from '../../components/ExtrasHelper';
import { QuoteOptionApiModel, SmartSendItemApiModel } from '~/lib/api/smartsend/types';

export function ReAddExistingExtrasToQuoteOption(
  item: SmartSendItemApiModel,
  quoteOption: QuoteOptionApiModel
): QuoteOptionApiModel {
  const o = { ...quoteOption };
  item?.Extras?.forEach((e) => {
    if (
      !ProtectionExtraIds.includes(e.Id) &&
      quoteOption.AvailableExtras.find((a) => a.Id === e.Id) &&
      !o.Extras.find((a) => a.Id == e.Id)
    ) {
      o.Extras.push({ ...e, Price: 0, Vat: 0, Total: 0 });
    }
  });
  return o;
}
